import { jsx } from 'react/jsx-runtime';
import { cn } from '../lib/utils.js';
import { motion } from 'motion/react';
import { memo, useMemo } from 'react';

const ShimmerComponent = ({ children, as: Component = "p", className, duration = 2, spread = 2, }) => {
    const MotionComponent = motion.create(Component);
    const dynamicSpread = useMemo(() => { var _a; return ((_a = children === null || children === void 0 ? void 0 : children.length) !== null && _a !== void 0 ? _a : 0) * spread; }, [children, spread]);
    return (jsx(MotionComponent, Object.assign({ animate: { backgroundPosition: "0% center" }, className: cn("tw:relative tw:inline-block tw:bg-[length:250%_100%,auto] tw:bg-clip-text tw:text-transparent", "tw:[--bg:linear-gradient(90deg,#0000_calc(50%-var(--spread)),var(--color-background),#0000_calc(50%+var(--spread)))] tw:[background-repeat:no-repeat,padding-box]", className), initial: { backgroundPosition: "100% center" }, style: {
            "--spread": `${dynamicSpread}px`,
            backgroundImage: "var(--bg), linear-gradient(var(--color-muted-foreground), var(--color-muted-foreground))",
        }, transition: {
            repeat: Number.POSITIVE_INFINITY,
            duration,
            ease: "linear",
        } }, { children: children })));
};
const Shimmer = memo(ShimmerComponent);

export { Shimmer };
//# sourceMappingURL=shimmer.js.map
